import React from 'react';

import { twMerge } from 'tailwind-merge';

import { Button } from '../../../../Clickables/Buttons/Button';
import { FilledBaitIcon } from '../../../../Icons/FilledBaitIcon';
import { Text } from '../../../../Text/Text';

interface GearButtonProps {
  children: string;
  className?: string;
  onClick?: () => void;
}

export const GearButton = ({ className, children, onClick: handleOnClick }: GearButtonProps) => {
  return (
    <Button
      className={twMerge('gap-2 !rounded-[36px] !bg-[#000000b3] px-[14px] py-[6px]', className)}
      onClick={handleOnClick}
      size="xs"
      variant="controlOnColorfulBg"
    >
      <FilledBaitIcon width="30" height="24" />
      <Text variant="sm" className="m-0 font-semibold">
        {children}
      </Text>
    </Button>
  );
};
